import { ForwardMailPromotionsComponent } from './fym-promotions.component';
import { ForwardMailPromotionsComponent as UdsForwardMailPromotionsComponent } from '../../new-design/promotions/fym-promotions.component';

import { ForwardMailPromotionsConfig } from './promotions.config';

export const ForwardMailPromotionsModule = angular
  .module('app.steps.forward-mail.promotions', [])
  .config(ForwardMailPromotionsConfig)
  .component('updFymPromotions', ForwardMailPromotionsComponent)
  .component('udsFymPromotions', UdsForwardMailPromotionsComponent);
